import { createSelector } from '@reduxjs/toolkit';

import { ApplicationState } from 'types/store';

const selectState = (state: ApplicationState) => state.audience.cart;

export const selectAudienceCartAudience = createSelector(selectState, ({ audience }) => audience);

export const selectAudienceCartIsSaved = createSelector(selectState, ({ isSaved }) => isSaved);

export const selectAudienceCartSave = createSelector(selectState, ({ save }) => save);

export const selectAudienceCartShop = createSelector(selectState, ({ shop }) => shop);
